import { FC, Fragment } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
  Divider,
  Button,
  Box,
} from '@mui/material';

interface MultipleSuggestionsProps {
  suggestions: string[];
  field: string;
  onSelect: (suggestion: string) => void;
  onClose: () => void;
}

export const MultipleSuggestions: FC<MultipleSuggestionsProps> = ({
  suggestions,
  field,
  onSelect,
  onClose,
}) => {
  const getFieldTitle = (fieldName: string): string => {
    switch (fieldName) {
      case 'discoverTitle':
        return 'Choisissez un titre discover';
      case 'partnerTitle':
        return "Choisissez un titre d'accroche";
      default:
        return `Choisissez un ${fieldName}`;
    }
  };
  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          maxHeight: '70vh',
        },
      }}
    >
      <DialogTitle sx={{ color: '#f44336', pb: 1 }}>
        {getFieldTitle(field)}
        <Typography
          variant="caption"
          display="block"
          sx={{ mt: 0.25, color: 'text.secondary' }}
        >
          {suggestions.length} suggestion{suggestions.length > 1 ? 's' : ''}{' '}
          disponible{suggestions.length > 1 ? 's' : ''}
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <List sx={{ maxHeight: '50vh', overflow: 'auto' }}>
          {suggestions.map((suggestion, index) => (
            <Fragment key={index}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => onSelect(suggestion)}
                  sx={{
                    py: 1,
                    px: 1.5,
                    '&:hover': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                >
                  <ListItemText
                    primary={
                      <Box
                        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            fontWeight: 500,
                            lineHeight: 1.4,
                            wordBreak: 'break-word',
                            flex: 1,
                          }}
                        >
                          {suggestion}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          sx={{
                            fontSize: '0.75rem',
                            whiteSpace: 'nowrap',
                            opacity: 0.7,
                          }}
                        >
                          • {suggestion.length} caractères
                        </Typography>
                      </Box>
                    }
                  />
                </ListItemButton>
              </ListItem>
              {index < suggestions.length - 1 && <Divider />}
            </Fragment>
          ))}
        </List>
      </DialogContent>

      <DialogActions sx={{ pt: 1, pb: 1.5 }}>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: '#f44336',
            color: 'white',
            '&:hover': {
              backgroundColor: '#d32f2f',
            },
          }}
        >
          Annuler
        </Button>
      </DialogActions>
    </Dialog>
  );
};
